import React, { useState, useEffect, useRef } from 'react';
import heroImage from '../images/wash_hero.jpg';
import heroImages from '../images/washing-1.jpg';
import { FaHome, FaWrench, FaSmile, FaThumbsUp } from 'react-icons/fa';
import CountUp from 'react-countup';



import './WashingMachineService.css';

function WashingMachineService() {



  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setInView(true);
          observer.unobserve(sectionRef.current);
        }
      },
      { threshold: 0.5 }
    );
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);

  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  }


  const [showSolution, setShowSolution] = useState({});

  const toggleSolution = (id) => {
    setShowSolution((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <>
      {/* Hero Section */}
      <div className="hero-container">
  <img src={heroImage} alt="Hero" className="hero-image" />
  <div className="hero-content">
    <div className="left-section">
      <h1 className="hero-title">Welcome to Chennai Washing Machine Care</h1>
      <p className="hero-description">
        Expert Washing Machine Repair & Maintenance Services for Your Home.
      </p>
      <button
        className="hero-button"
        onClick={() => (window.location.href = 'tel:+918270096596')}
      >
        Book Now:  82700 96596
      </button>
    </div>
  </div>
</div>


      {/* Service Section */}
      <div className="service-section">
        <div className="service-container">
          <div className="service-image">
            <img src={heroImages} alt="Washing Machine Repair" />
          </div>
          <div className="service-description">
            <h2>Washing Machine Service</h2>
            <p>
              At <strong>Chennai Home Appliance Care</strong>, our expert technicians provide reliable and fast washing machine repair services for all major brands. Whether it's a mechanical fault, electrical issue, or any other problem, we're here to help. Our services include thorough diagnosis, efficient repairs, and preventive maintenance to ensure your washing machine operates at its best.
            </p>
          </div>
        </div>
      </div>






      <div className="service-section">
  <div className="service-container">
    <div className="left-column">
      <h2 className="service-title">Expert Washing Machine Service</h2>
      <p className="service-description">
        Our experienced technicians are equipped with the latest tools and training to provide expert washing machine services. Whether it's a repair, maintenance, or installation, we ensure high-quality service at affordable prices.
      </p>
    </div>
    <div className="right-column">
      <div className="service-item">
        <div className="icon-container">
          <i className="fas fa-certificate"></i> {/* Font Awesome icon for Certification */}
        </div>
        <h3 className="service-heading">Certified</h3>
        <p className="service-description">
          We are a certified service provider, ensuring the highest quality repairs and services.
        </p>
      </div>
      <div className="service-item">
        <div className="icon-container">
          <i className="fas fa-check-circle"></i> {/* Font Awesome icon for Trusted */}
        </div>
        <h3 className="service-heading">Trusted</h3>
        <p className="service-description">
          Our trusted technicians are always ready to provide quick and reliable solutions to your appliance problems.
        </p>
      </div>
      <div className="service-item">
        <div className="icon-container">
          <i className="fas fa-tools"></i> {/* Font Awesome icon for Professional Tools */}
        </div>
        <h3 className="service-heading">Professional Tools</h3>
        <p className="service-description">
          We use professional-grade tools to ensure that every service is done right the first time.
        </p>
      </div>
      <div className="service-item">
        <div className="icon-container">
          <i className="fas fa-thumbs-up"></i> {/* Font Awesome icon for Quality */}
        </div>
        <h3 className="service-heading">Quality</h3>
        <p className="service-description">
          Our focus is on delivering high-quality services that exceed customer expectations.
        </p>
      </div>
    </div>
  </div>
</div>











      {/* Repair Issues Section */}
      <div className="repair-container">
        <h1>Common Washing Machine Issues & Solutions</h1>
        <div className="issues-grid">
          {/* Issue 1 */}
          <div className="issue">
            <h2>Issue 1: Washing Machine Won't Start</h2>
            <p>This could be due to a power supply problem or an internal fault.</p>
            <button className="solution-btn" onClick={() => toggleSolution('solution1')}>
              {showSolution['solution1'] ? 'Hide Solution' : 'View Solution'}
            </button>
            {showSolution['solution1'] && (
              <div className="solution">
                <p>Check the power outlet and ensure the power cord is connected properly. If the issue persists, contact a professional technician.</p>
              </div>
            )}
          </div>

          {/* Issue 2 */}
          <div className="issue">
            <h2>Issue 2: Washer Not Draining</h2>
            <p>The washer may not be draining due to a clogged drain hose or filter.</p>
            <button className="solution-btn" onClick={() => toggleSolution('solution2')}>
              {showSolution['solution2'] ? 'Hide Solution' : 'View Solution'}
            </button>
            {showSolution['solution2'] && (
              <div className="solution">
                <p>Check the drain hose for any blockages and clean the filter. If necessary, call a technician for further assistance.</p>
              </div>
            )}
          </div>

          {/* Issue 3 */}
          <div className="issue">
            <h2>Issue 3: Excessive Vibration</h2>
            <p>This may be caused by an unbalanced load or faulty shock absorbers.</p>
            <button className="solution-btn" onClick={() => toggleSolution('solution3')}>
              {showSolution['solution3'] ? 'Hide Solution' : 'View Solution'}
            </button>
            {showSolution['solution3'] && (
              <div className="solution">
                <p>Ensure the load is balanced and check if the shock absorbers need replacement. Adjust the leveling feet if necessary.</p>
              </div>
            )}
          </div>

          {/* Issue 4 */}
          <div className="issue">
            <h2>Issue 4: Washing Machine Leaks</h2>
            <p>Leaking could be due to a loose hose connection or damaged seal.</p>
            <button className="solution-btn" onClick={() => toggleSolution('solution4')}>
              {showSolution['solution4'] ? 'Hide Solution' : 'View Solution'}
            </button>
            {showSolution['solution4'] && (
              <div className="solution">
                <p>Inspect the hoses and seals for any signs of damage. Tighten any loose connections or replace damaged parts.</p>
              </div>
            )}
          </div>
        </div>
      </div>






      <div className="company-service-section">
        <h2>Why Choose Chennai Home Appliance Care?</h2>
        <p>We offer a variety of washing machine services, including top-load and front-load repairs, right at your doorstep. Our goal is 100% customer satisfaction with reliable, expert service.</p>
        
        <div className="icon-grid">
          <div className="icon-card">
            <FaHome className="service-icon" />
            <h3>Home Service</h3>
            <p>Our technicians come to your home to perform all repairs.</p>
          </div>
          <div className="icon-card">
            <FaWrench className="service-icon" />
            <h3>Top-Load & Front-Load</h3>
            <p>We handle both top-load and front-load washing machines.</p>
          </div>
          <div className="icon-card">
            <FaSmile className="service-icon" />
            <h3>100% Satisfaction</h3>
            <p>We are committed to achieving 100% customer satisfaction.</p>
          </div>
          <div className="icon-card">
            <FaThumbsUp className="service-icon" />
            <h3>Expert Technicians</h3>
            <p>Our technicians are skilled and experienced in appliance repair.</p>
          </div>
        </div>
        </div>


          {/* Testimonials Section */}
          <div className="testimonials-section">
  <h2>What Our Customers Say</h2>
  <div className="testimonials-carousel">
    <div className="testimonial">
      <p>"Excellent service! My washing machine was fixed in no time."</p>
      <span>- Sarah, Chennai</span>
    </div>
    <div className="testimonial">
      <p>"Reliable and professional. Highly recommend Chennai Home Appliance Care!"</p>
      <span>- Rajesh, Chennai</span>
    </div>
    <div className="testimonial">
      <p>"Quick response and affordable prices. I'm very satisfied with the service!"</p>
      <span>- Priya, Chennai</span>
    </div>
    <div className="testimonial">
      <p>"Very skilled technicians. They solved my appliance issue in just one visit!"</p>
      <span>- Anil, Chennai</span>
    </div>
  </div>
</div>

    <div className="faq-section">
      <h2>Frequently Asked Questions</h2>
      <div className="faq-item" onClick={() => toggleFAQ(1)}>
        <h3>How long does a washing machine repair usually take?</h3>
        {openFAQ === 1 && <p>Most repairs take between 1-2 hours, depending on the complexity of the issue.</p>}
      </div>
      <div className="faq-item" onClick={() => toggleFAQ(2)}>
        <h3>Do you provide a warranty on repairs?</h3>
        {openFAQ === 2 && <p>Yes, we provide a 30-day warranty on all repairs to ensure customer satisfaction.</p>}
      </div>
      <div className="faq-item" onClick={() => toggleFAQ(3)}>
        <h3>What types of washing machines do you service?</h3>
        {openFAQ === 3 && <p>We service both top-load and front-load washing machines from all major brands.</p>}
      </div>
      <div className="faq-item" onClick={() => toggleFAQ(4)}>
        <h3>How do I book a repair service?</h3>
        {openFAQ === 4 && <p>You can book a repair service by calling us directly or filling out our online booking form.</p>}
      </div>
    </div>



    <div className="countdown-section" ref={sectionRef}>
      <h2>Our Achievements</h2>
      <div className="countdown-grid">
        {/* Counter 1 */}
        <div className="counter">
          <h3>Years of Experience</h3>
          {inView && (
            <CountUp start={0} end={15} duration={2} suffix="+" className="count-number" />
          )}
        </div>
        
        {/* Counter 2 */}
        <div className="counter">
          <h3>Customers Satisfied</h3>
          {inView && (
            <CountUp start={0} end={500} duration={2.5} suffix="+" className="count-number" />
          )}
        </div>

        {/* Counter 3 */}
        <div className="counter">
          <h3>Projects Completed</h3>
          {inView && (
            <CountUp start={0} end={200} duration={3} suffix="+" className="count-number" />
          )}
        </div>

        {/* Counter 4 */}
        <div className="counter">
          <h3>Awards Won</h3>
          {inView && (
            <CountUp start={0} end={15} duration={2} suffix="+" className="count-number" />
          )}
        </div>
      </div>
    </div>
 <div className="cta-section">
        <h2>Need Help with Your Washing Machine?</h2>
        <p>Contact us today to schedule a service!</p>
        <button className="cta-button" onClick={() => (window.location.href = 'tel:+918270096596')}>
          Call Us:  82700 96596
        </button>
      </div>
     

    </>
  );
}


export default WashingMachineService;
